import { useEffect, useState } from 'react'
import { Toast, toastStore } from '../../utils/errors'

export function ToastContainer() {
  const [toasts, setToasts] = useState<Toast[]>([])

  useEffect(() => {
    return toastStore.subscribe(setToasts)
  }, [])

  if (toasts.length === 0) return null

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          style={{
            animation: 'fadeIn 0.3s ease-out',
          }}
          className={`px-4 py-3 rounded-lg shadow-lg text-white min-w-[300px] max-w-[500px] ${
            toast.type === 'error'
              ? 'bg-red-600'
              : toast.type === 'warning'
              ? 'bg-yellow-600'
              : toast.type === 'success'
              ? 'bg-green-600'
              : 'bg-blue-600'
          }`}
        >
          <div className="flex items-start gap-3">
            <span className="text-lg">
              {toast.type === 'error'
                ? '❌'
                : toast.type === 'warning'
                ? '⚠️'
                : toast.type === 'success'
                ? '✅'
                : 'ℹ️'}
            </span>
            <p className="flex-1 text-sm">{toast.message}</p>
            <button
              onClick={() => toastStore.remove(toast.id)}
              className="text-white/80 hover:text-white text-lg leading-none"
            >
              ×
            </button>
          </div>
        </div>
      ))}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  )
}
